import React from 'react';
import './Response.scss';

const renderAnswer = (questionType, answer) => {
  if (questionType === 'multiselect') {
    return (
      <ul className="multiselect-answers">
        {answer.map((ans) => (
          <li key={`${ans.id}-${ans.text}`}>{ans.text}</li>
        ))}
      </ul>
    );
  }
  return answer ? answer.text : '';
};

const shouldRenderResponse = (question) => {
  if (question.conditions && question.conditions.length > 0) {
    return question.answer;
  }

  return true;
};

const Response = ({ question }) => {
  return (
    shouldRenderResponse(question) && (
      <tr className="response-wrapper">
        <td className="question-cell">{question.text}</td>
        <td className="answer-cell">
          {renderAnswer(question.type, question.answer)}
        </td>
      </tr>
    )
  );
};

export default Response;
